import moment from 'moment';
import {useEffect, useState} from 'react';
import React from 'react';

export const useCountdown = (endDate) => {
  const [currentTime, setCurrentTime] = useState(moment());

  const timeBetween = moment.duration(
    (typeof endDate === 'string' ? moment(endDate, 'YYYY-MM-DD H:mm:ss') : endDate).diff(currentTime),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return {
    days: timeBetween.days(),
    hours: timeBetween.hours(),
    minutes: timeBetween.minutes(),
    seconds: timeBetween.seconds(),
  };
};

export const CardCounterBanner = ({item}) => {
  const endDate = moment(item?.end_date, 'YYYY-MM-DD H:mm:ss').endOf('day');
  const {days, hours, minutes, seconds} = useCountdown(endDate);
  const [render, setRender] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 1000);
  }, []);

  return (
    <>
      {!!item && !!render && item?.type === 'FLASH_SALE' && (
        <div>
          <div className="contador">
            <div>
              <div>
                <span>{days}</span>
              </div>
              <h4>DÍAS</h4>
            </div>
            <p>:</p>
            <div>
              <div>
                <span>{hours}</span>
              </div>
              <h4>HRS</h4>
            </div>
            <p>:</p>
            <div>
              <div>
                <span>{minutes}</span>
              </div>
              <h4>MIN</h4>
            </div>
            <p>:</p>
            <div>
              <div>
                <span>{seconds}</span>
              </div>
              <h4>SEG</h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
